import * as React from 'react';
export default class BmaProductAlloySpecification extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = { review: {}, alloy: '' };
    }
    public async componentDidMount() {
        if (this.props.snapShotId) {
            await this.loadBmaProductSpecification();
        }
    }
    public async componentDidUpdate(previewProps: any) {
        if (previewProps.productsCount !== this.props.productsCount && this.props.snapShotId) {
            await this.loadBmaProductSpecification();
        }
    }

    private loadBmaProductSpecification = async () => {
        const bmaReviewEndPoint = this.props.context.app.config.bmaReviewEndPoint.replace('#snapshotId', this.props.snapShotId);
        const response = await fetch(`${this.props.context.app.config.bmaBaseUrl}${bmaReviewEndPoint}`);
        const review = await response.json();
        const alloy = `${this.props.translationInfo[review[0].properties.disc.fineness[0].label]}
                                ${''}${this.props.translationInfo[review[0].properties.disc.color[0].label]}`;
        this.setState({ review: review, alloy: alloy });
    };
    public render(): JSX.Element | null {
        return <span className={'bma-product-alloy'}>{this.state.alloy}</span>;
    }
}
